import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {LookupService} from '../../../../common/service/lookup.service';
import {labelProperties, Attributes} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class PointLabelExpressionBuilderService {
    title = 'PointLabelExpressionBuilder';

    constructor(
        private lookupService: LookupService,
        private labelExpressionUtilityService: LabelExpressionUtilityService
    ) {}

    format(value: string) {
        return value ? `<FNT name='Arial' size='7.2'>${this.labelExpressionUtilityService.encodeSpecialCharacters(value)}</FNT>` : null;
    }

    getLabelProperties(attributes: string) {
        return this.labelExpressionUtilityService.getLabelProperties('7.2em', 'normal', 'start', attributes);
    }

    getAttribute1(attrs: Attributes) {
        if (!attrs.attribute1) {
            return;
        }
        let pointTypeLookup = this.lookupService.getLookups('pointType').find(l => [l.id, l.description].includes(attrs.attribute1));
        return pointTypeLookup && pointTypeLookup.description;
    }

    getAttribute2(attrs: Attributes) {
        if (!attrs.attribute2) {
            return;
        }

        let pmsLookup = this.lookupService.getLookups('pointMarkStatus').find(l => [l.id, l.description, l.displayLabel].includes(attrs.attribute2));
        return pmsLookup && pmsLookup.displayLabel;
    }

    build(attrs: Attributes) {
        console.debug(`${this.title} : build`);

        let labels = [];
        let attribute1 = this.getAttribute1(attrs);
        let attribute2 = this.getAttribute2(attrs);

        attribute1 && labels.push(this.getLabelProperties(this.getAttribute1(attrs)));
        attribute2 && labels.push(this.getLabelProperties(this.getAttribute2(attrs)));

        attrs.attribute3 && labels.push(this.getLabelProperties(attrs.attribute3));
        if (attrs.attribute4) {
            let attribute4Lines = attrs.attribute4.split(/[\r\n]/g);
            labels.push(...attribute4Lines.map(s => this.getLabelProperties(s)));
        }

        let labelProperties = {} as labelProperties;

        labelProperties.labels = labels;
        labelProperties.labelExpression = this.format(
            [this.getAttribute1(attrs), this.getAttribute2(attrs), attrs.attribute3, attrs.attribute4].filter(v => v).join('\n')
        );

        return labelProperties;
    }
}
